import { faFacebookSquare, faGithub, faLinkedinIn, faStackOverflow, faTwitterSquare, faMedium } from '@fortawesome/free-brands-svg-icons';
import { faEnvelopeSquare } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css'
const githubURL = 'github.com/Shadow-Chaser';
const fbURL = 'facebook.com/ashabhussan.tanim';
const twitterURL = 'twitter.com/AshabHussan';
const linkedInURL = 'linkedin.com/in/ashabhussan';
const stackURl = 'stackoverflow.com/users/15795977/shadow-chaser';
const mailURL = 'mailto:ashabhtanim@gmail.com';
const mediumURL = 'ashabhussan.medium.com'

const Footer = () => {
    return (
        <div className='footer'>
            <div className="social text-center p-4">
                <a rel='noreferrer' href="mailto: ashabhtanim@gmail.com" > <FontAwesomeIcon className='m-2 icon' icon={faEnvelopeSquare} /></a>
                <Link target='_blank' to={"//" + fbURL} > <FontAwesomeIcon className='m-2 icon' icon={faFacebookSquare} /></Link>
                <Link target='_blank' to={"//" + twitterURL} > <FontAwesomeIcon className='m-2 icon' icon={faTwitterSquare} /></Link>
                <Link target='_blank' to={"//" + githubURL} > <FontAwesomeIcon className='m-2 icon' icon={faGithub} /></Link>
                <Link target='_blank' to={"//" + linkedInURL} > <FontAwesomeIcon className='m-2 icon' icon={faLinkedinIn} /></Link>
                <Link target='_blank' to={"//" + mediumURL} > <FontAwesomeIcon className='m-2 icon' icon={faMedium} /></Link>
                <Link target='_blank' to={"//" + stackURl} > <FontAwesomeIcon className='m-2 icon' icon={faStackOverflow} /></Link>
            </div>
            <p className="text-center text-white p-4">Copyright © 2021. All rights reserved</p>
        </div>
    );
};

export default Footer;